import gql from 'graphql-tag';

export const getCoursesUserEnrolledIn = gql`
  query userCourses {
    userCourses {
      id
      enrollmentDate
    }
  }
`;

export const getSubmodulesUserEnrolledIn = gql`
  query userSubmodules($courseId: String!) {
    userSubmodules(data: { courseId: $courseId }) {
      submodules
    }
  }
`;

export const getUserRegisteredDisciplinesIdsByCourse = gql`
  query getUserDisciplinesIdsByCourse($courseId: String!) {
    getUserDisciplinesIdsByCourse(data: { courseId: $courseId }) {
      disciplinesIds
    }
  }
`;
